module.exports = __webpack_public_path__ + "img/button_list.7b1cd717.svg";